import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;

  // Vendor sessions live under /vendor, never in the staff dashboard
  if (user.actorType === 'vendor') return <Navigate to="/vendor" />;

  return children;
};

export default ProtectedRoute;